import { GET_OWNED_NFTS, SAVE_CONNECTED_WALLET, SET_CONNECTED_WALLET, SET_LIKED, SET_PROFILE } from "./constants";

export function setProfile(profile) {
  return {
    type: SET_PROFILE,
    profile,
  };
}
export function userClickLike(postId, isLiked) {
  return {
    type: SET_LIKED,
    postId,
    isLiked
  }
}
export function saveWallet(method, wallet, cbSuccess) {
  return {
    type: SAVE_CONNECTED_WALLET,
    method,
    wallet,
    cbSuccess
  }
}
export function setWallet(wallet) {
  return {
    type: SET_CONNECTED_WALLET,
    wallet
  }
}
export function getNfts(address) {
  return {
    type: GET_OWNED_NFTS,
    address
  }
}